import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  TCreateCallCenterPayload,
  TUpdateCallCenterPayload,
} from "@/models/call-centers.model";
import * as callCentersService from "@/services/call-center/call-centers.service";

export const fetchCallCenters = createAsyncThunk(
  "callCenters/fetchCallCenters",
  async (_, { signal, rejectWithValue }) => {
    try {
      return await callCentersService.getCallCenters(signal);
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const fetchCallCenter = createAsyncThunk(
  "callCenters/fetchCallCenter",
  async (id: number, { signal, rejectWithValue }) => {
    try {
      return await callCentersService.getCallCenter(id, signal);
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const createCallCenter = createAsyncThunk(
  "callCenters/createCallCenter",
  async (payload: TCreateCallCenterPayload, { rejectWithValue }) => {
    try {
      return await callCentersService.createCallCenter(payload);
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const updateCallCenter = createAsyncThunk(
  "callCenters/updateCallCenter",
  async (payload: TUpdateCallCenterPayload, { rejectWithValue }) => {
    try {
      return await callCentersService.updateCallCenter(payload);
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);

export const deleteCallCenter = createAsyncThunk(
  "callCenters/deleteCallCenter",
  async (id: number, { rejectWithValue }) => {
    try {
      await callCentersService.deleteCallCenter(id);
      return id;
    } catch (e) {
      return rejectWithValue(e);
    }
  }
);
